export const getCalendarDays = (appointments = [], selectedDate = new Date()) => {
  const year = selectedDate.getFullYear();
  const month = selectedDate.getMonth();
  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const firstDayIndex = firstDayOfMonth.getDay();
  const totalDays = lastDayOfMonth.getDate();

  const days = [];

  const leadingDays = firstDayIndex === 0 ? 6 : firstDayIndex - 1;
  for (let i = 0; i < leadingDays; i += 1) {
    days.push({ date: null, dateKey: '', isCurrentMonth: false, appointments: [] });
  }

  const monthAppointments = appointments.reduce((acc, appointment) => {
    if (appointment.date) {
      acc[appointment.date] = acc[appointment.date] || [];
      acc[appointment.date].push(appointment);
    }
    return acc;
  }, {});

  for (let day = 1; day <= totalDays; day += 1) {
    const currentDate = new Date(year, month, day);
    const dateKey = currentDate.toISOString().split('T')[0];
    days.push({
      date: currentDate,
      dateKey,
      isCurrentMonth: true,
      appointments: monthAppointments[dateKey] || [],
    });
  }

  const trailingSlots = (7 - (days.length % 7)) % 7;
  for (let i = 0; i < trailingSlots; i += 1) {
    days.push({ date: null, dateKey: '', isCurrentMonth: false, appointments: [] });
  }

  return days;
};
